import React from 'react';
import { StyledSubHeader } from '../Styled';
import {
  StyledProcedureUnorderedList,
  StyledProcedureItem,
  StyledProcedureOrderedList,
  StyledSequenceNumberItem,
} from '../Styled/StyledList';
import { CONSOLIDATING, EXTENDING } from '../../constants';

interface IProcedureList {
  styles: Array<string>;
  sequenceNumber: string;
  color: string;
  stage: string;
  children: JSX.Element;
}

export enum ProcedureElements {
  UNORDERED_LIST = 'unordered-list',
  ORDERED_LIST = 'ordered-list',
  SUB_HEADING = 'sub-heading',
}

export const ProcedureItemList: React.FC<IProcedureList> = (props): JSX.Element => {
  const { styles, sequenceNumber, color, stage } = props;

  if (styles.includes(ProcedureElements.UNORDERED_LIST)) {
    return (
      <StyledProcedureUnorderedList>
        <StyledProcedureItem color={color}>{props.children}</StyledProcedureItem>
      </StyledProcedureUnorderedList>
    );
  }

  if (styles.includes(ProcedureElements.ORDERED_LIST)) {
    const isConsolidatingOrExtending = stage === CONSOLIDATING || stage === EXTENDING;

    return (
      <StyledProcedureOrderedList>
        <StyledSequenceNumberItem color={color} isMarkerBold={isConsolidatingOrExtending} value={sequenceNumber}>
          {props.children}
        </StyledSequenceNumberItem>
      </StyledProcedureOrderedList>
    );
  }

  if (styles.includes(ProcedureElements.SUB_HEADING)) {
    const defaultFontSize = 23;
    const extendingOrConsolidatingFontSize = 20;

    const isConsolidatingOrExtending = stage === CONSOLIDATING || stage === EXTENDING;

    const fontSize = isConsolidatingOrExtending ? extendingOrConsolidatingFontSize : defaultFontSize;

    return (
      <StyledSubHeader data-testid="sub-header" stage={stage} fontSize={fontSize} color={color}>
        {props.children}
      </StyledSubHeader>
    );
  }

  return props.children as JSX.Element;
};
